import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';
import FeedCard from '../components/FeedCard';
import Loader from '../components/Loader';

/* One post and its whole conversation. The same card as the feed, opened —
   so a post looks like itself wherever it is. */
export default function PostDetail({ postId, notify, onBack }) {
  const [item, setItem] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    api
      .post(postId)
      .then((p) => setItem({ ...p, type: 'post', reason: '', recent_comments: p.comments }))
      .catch((e) => setError(e.message));
  }, [postId]);

  return (
    <>
      <button className="linklike back-link" onClick={onBack}>← back to Home</button>
      {error && <div className="pe-error">{error}</div>}
      {!item && !error && <Loader />}
      {item && <FeedCard item={item} notify={notify} open />}
    </>
  );
}
